import type { MetaDescriptor } from 'react-router'
import { useParams } from 'react-router'
import ServicePageTemplate from '../../templates/ServicePageTemplate'
import NotFoundPage from '../../pages/NotFound/NotFoundPage'
import { getServiceBySlug } from '../../content/services'
import { getEntryByIdString } from '../../content/registry'
import { buildPageMeta } from '../../seo/meta'

export const handle = { locale: 'nl' }

export function meta({ params }: { params: Record<string, string | undefined> }): MetaDescriptor[] {
  const service = getServiceBySlug(params.serviceId ?? '', 'nl')
  if (!service) return [{ title: '404' }, { name: 'robots', content: 'noindex, follow' }]
  const entry = getEntryByIdString(`service:${service.id}`)
  return entry ? buildPageMeta({ entry, locale: 'nl' }) : []
}

export default function Route() {
  const { serviceId } = useParams()
  const service = getServiceBySlug(serviceId ?? '', 'nl')
  if (!service) return <NotFoundPage locale='nl' />
  return <ServicePageTemplate service={service} locale='nl' />
}
